import script from "./StructureForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./StructureForm.vue?vue&type=script&lang=ts&setup=true"

import "./StructureForm.vue?vue&type=style&index=0&id=f6e036a8&lang=scss"

const __exports__ = script;

export default __exports__